//import React from "react";
import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "../styles/Footer.css";
import ThemeSelector from "./ThemeSelector";

import { initializeApp } from "firebase/app";
import { getAnalytics, logEvent } from "firebase/analytics";
import {
  getDatabase,
  ref,
  update,
  onValue,
  increment,
} from "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSyCrwsyvzZaQ4l4wPc9mtnZMDA3tHbg5StY",
  authDomain: "ihariprabodham-76c62.firebaseapp.com",
  projectId: "ihariprabodham-76c62",
  databaseURL:
    "https://ihariprabodham-76c62-default-rtdb.asia-southeast1.firebasedatabase.app",
  storageBucket: "ihariprabodham-76c62.firebasestorage.app",
  messagingSenderId: "995704795773",
  appId: "1:995704795773:web:c02e9802f2c74a94c5f714",
  measurementId: "G-JSEH2L7SQK",
};

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getDatabase(app);

function Footer() {
  const location = useLocation();
  // Scroll to top on route change
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);
  const [visitorCount, setVisitorCount] = useState(0);
  useEffect(() => {
    // Increment visit count
    const visitsRef = ref(db, "pageVisits");
    update(visitsRef, { total: increment(1) });
    // Listen for count changes
    const totalRef = ref(db, "pageVisits/total");
    onValue(totalRef, (snapshot) => {
      setVisitorCount(snapshot.val() || 0);
    });

    // Log analytics event
    logEvent(analytics, "page_view", {
      page_title: document.title,
      page_location: window.location.href,
    });
  }, []);

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <h3>Quick Links</h3>
          <ul>
            {/* <li>
              <a
                href="http://www.hpym.org"
                target="_blank"
                rel="noopener noreferrer"
              >
                HPYM
              </a>
            </li>
            <li>
              <a
                href="https://ihariprabodham.org/MariSmruti/login"
                target="_blank"
                rel="noopener noreferrer"
              >
                Mari Smruti
              </a>
            </li>  */}
            <li>
              <Link to="/hariprabodham-dham">Hariprabodham Dham</Link>
            </li>
            <li>
              <Link to="/centers">Hariprabodham Centers</Link>
            </li>
          </ul>
        </div>

        <div className="footer-section">
          <h3>Spotify</h3>
          <ul style={{ maxWidth: "440px" }}>
            <li>
              <Link to="/spotify">iHariprabodham Spotify</Link>
            </li>

            <li>
              <Link to="/hariprabodham-spotify">Hariprabodham Spotify</Link>
            </li>
            <li>
              <Link to="/niramay-studios">Niramay Studios Spotify</Link>
            </li>
            <li>
              <Link to="/iakshar-spotify">I Am Akshar Spotify</Link>
            </li>
            <li>
              <Link to="/toronto-rhythm-spotify">Toronto Rhythm Spotify</Link>
            </li>
            <li>
              <Link to="/ambrish-upnishad-spotify">
                Ambrish Upnishad Spotify
              </Link>
            </li>
          </ul>
        </div>
        <div className="footer-section">
          <h3>Connect Us</h3>
          <div className="social-icons">
            <a
              href="https://x.com/iHariPrabodham"
              target="_blank"
              rel="noopener noreferrer"
              className="social-icon"
              title="X"
            >
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24h-6.657l-5.207-6.807-5.966 6.807H2.25l7.73-8.835L1.13 2.25h6.882l4.791 6.318 5.452-6.318zM17.15 18.738h1.828L6.122 4.146H4.231l12.919 14.592z" />
              </svg>
            </a>
            <a
              href="https://www.instagram.com/ihariprabodham/"
              target="_blank"
              rel="noopener noreferrer"
              className="social-icon"
              title="Instagram"
            >
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
                <path d="M16 11.37A4 4 0 1112.63 8 4 4 0 0116 11.37Z" />
                <circle cx="17.5" cy="6.5" r="1.5" />
              </svg>
            </a>
            <a
              href="https://www.facebook.com/ihariprabodham/"
              target="_blank"
              rel="noopener noreferrer"
              className="social-icon"
              title="Facebook"
            >
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M18 2h-3a6 6 0 00-6 6v3H7v4h2v8h4v-8h3l1-4h-4V8a1 1 0 011-1h3z" />
              </svg>
            </a>
            <a
              href="https://www.youtube.com/@iHariPrabodham"
              target="_blank"
              rel="noopener noreferrer"
              className="social-icon"
              title="YouTube"
            >
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M22.54 6.42c-.26-1.17-1.04-2.09-2.12-2.35C18.88 3.5 12 3.5 12 3.5s-6.88 0-8.42.57c-1.08.26-1.86 1.18-2.12 2.35C.97 7.99.97 12 .97 12s0 4.01.37 5.58c.26 1.17 1.04 2.09 2.12 2.35 1.54.57 8.42.57 8.42.57s6.88 0 8.42-.57c1.08-.26 1.86-1.18 2.12-2.35.37-1.57.37-5.58.37-5.58s0-4.01-.37-5.58zM9.75 15.02v-6.04l5.38 3.02-5.38 3.02z" />
              </svg>
            </a>
            <a
              href="https://open.spotify.com/artist/2jgjzIrtQxmiWJSsD4sKsw?si=DZ6zXXu5TyyvPRBJzBDK7w"
              target="_blank"
              rel="noopener noreferrer"
              className="social-icon"
              title="Spotify"
            >
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 0C5.373 0 0 5.373 0 12c0 6.628 5.373 12 12 12s12-5.372 12-12c0-6.627-5.373-12-12-12zm5.338 17.419a.748.748 0 0 1-1.03.248c-2.822-1.731-6.38-2.123-10.593-1.158a.75.75 0 1 1-.33-1.464c4.61-1.04 8.57-.593 11.73 1.318a.75.75 0 0 1 .223 1.056zm1.47-3.13a.937.937 0 0 1-1.29.31c-3.23-1.984-8.146-2.56-11.96-1.396a.937.937 0 1 1-.54-1.796c4.296-1.29 9.73-.648 13.39 1.58a.937.937 0 0 1 .4 1.302zm.13-3.36c-3.7-2.2-9.84-2.4-13.42-1.3a1.125 1.125 0 0 1-.66-2.15c4.1-1.26 10.02-1.02 14.3 1.46a1.125 1.125 0 0 1-1.22 1.99z" />
              </svg>
            </a>
            <a
              href="https://music.apple.com/in/artist/ihariprabodham/1843252069"
              target="_blank"
              rel="noopener noreferrer"
              className="social-icon"
              title="Apple Music"
            >
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M23.994 6.124a9.23 9.23 0 0 0-.24-2.19c-.317-1.31-1.062-2.31-2.18-3.043a5.022 5.022 0 0 0-1.877-.726 10.496 10.496 0 0 0-1.564-.15c-.04-.003-.083-.01-.124-.013H5.986c-.152.01-.303.017-.455.026-.747.043-1.49.123-2.193.4-1.336.53-2.3 1.452-2.865 2.78-.192.448-.292.925-.363 1.408-.056.392-.088.785-.1 1.18 0 .032-.007.062-.01.093v12.223c.01.14.017.283.027.424.05.815.154 1.624.497 2.373.65 1.42 1.738 2.353 3.234 2.802.42.127.856.187 1.293.228.555.053 1.11.06 1.667.06h11.03a12.5 12.5 0 0 0 1.57-.1c.822-.106 1.596-.35 2.295-.81a5.046 5.046 0 0 0 1.88-2.207c.186-.42.293-.87.37-1.324.113-.675.138-1.358.137-2.04-.002-3.8 0-7.595-.003-11.393zm-6.423 3.99v5.712c0 .417-.058.827-.244 1.206-.29.59-.76.962-1.388 1.14-.35.1-.706.157-1.07.173-.95.042-1.785-.455-2.105-1.346-.227-.633-.145-1.25.237-1.81.283-.415.675-.68 1.14-.86.33-.13.68-.2 1.027-.26.39-.065.78-.123 1.17-.187.19-.03.33-.14.38-.32.02-.06.03-.12.03-.19V9.41c0-.12-.05-.23-.15-.3a.482.482 0 0 0-.33-.07l-4.43.92c-.036.01-.07.024-.1.04a.28.28 0 0 0-.16.27v7.63c0 .41-.055.814-.235 1.19-.283.59-.747.97-1.373 1.15-.344.1-.698.158-1.055.176-.96.048-1.8-.436-2.136-1.328-.24-.64-.166-1.26.215-1.824.278-.41.664-.68 1.12-.864.326-.134.67-.2 1.016-.267.39-.07.78-.13 1.17-.2.27-.05.44-.2.49-.47.01-.06.01-.12.01-.18V7.67c0-.17.04-.32.16-.45.14-.14.32-.2.51-.24L16.2 5.79c.12-.03.25-.04.37-.03.29.02.51.22.55.5.01.06.01.12.01.18v3.66z" />
              </svg>
            </a>
          </div>
        </div>
        <div className="footer-section">
          <h3>Apps</h3>
          <div className="apps-container">
            <div className="app-platform">
              <h4>
                <svg
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  className="platform-icon"
                >
                  <path d="M3 13.5h8v8H3z" />
                  <path d="M13 3h8v8h-8z" />
                  <path d="M13 13h8v8h-8z" />
                  <path d="M3 3h8v8H3z" />
                </svg>
                Android Apps
              </h4>
              <div className="app-links-grid">
                <a
                  href="https://play.google.com/store/apps/details?id=org.hariprabodham.ihariprabodham"
                  className="app-link"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="iHariPrabodham App"
                >
                  <img
                    src="/image/ihp.png"
                    alt="iHariPrabodham App"
                    style={{ width: 24, height: 24 }}
                  />
                </a>
                <a
                  href="https://play.google.com/store/apps/details?id=com.hari.patrika.patrika"
                  className="app-link"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="HariPrabodham App"
                >
                  <img
                    src="/image/hp.png"
                    alt="HariPrabodham App"
                    style={{ width: 24, height: 24 }}
                  />
                </a>
                <a
                  href="https://play.google.com/store/apps/details?id=org.hariprabodham.swaminivato"
                  className="app-link"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Paramrut App"
                >
                  <img
                    src="/image/paramrut.jpg"
                    alt="Paramrut App"
                    style={{ width: 24, height: 24 }}
                  />
                </a>
                <a
                  href="https://play.google.com/store/apps/details?id=org.hariprabodham.kirtan"
                  className="app-link"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Hari Kirtan App"
                >
                  <img
                    src="/image/kirtan.png"
                    alt="Hari Kirtan App"
                    style={{ width: 24, height: 24 }}
                  />
                </a>
                <a
                  href="https://play.google.com/store/apps/details?id=com.suhradvrund"
                  className="app-link"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Hariprabodham Vrund App"
                >
                  <img
                    src="/image/vrund.jpg"
                    alt="Hariprabodham Vrund App"
                    style={{ width: 24, height: 24 }}
                  />
                </a>

                <a
                  href="https://play.google.com/store/apps/details?id=org.hp.harismruti"
                  className="app-link"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Hariprabodham Smruti App"
                >
                  <img
                    src="/image/smruti.png"
                    alt="Hariprabodham Smruti App"
                    style={{ width: 24, height: 24 }}
                  />
                </a>
                <a
                  href="https://play.google.com/store/apps/details?id=org.calendar.atmiyacalendar"
                  className="app-link"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Atmiya Calendar App"
                >
                  <img
                    src="/image/calendar.png"
                    alt="Atmiya Calendar App"
                    style={{ width: 24, height: 24 }}
                  />
                </a>
              </div>
            </div>
            <div className="app-platform">
              <h4>
                <svg
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  className="platform-icon"
                >
                  <path d="M17.05 13.5c-.91 0-1.64.75-1.64 1.67s.73 1.67 1.64 1.67 1.64-.75 1.64-1.67-.73-1.67-1.64-1.67m-4.5-5c-.83 0-1.48.67-1.48 1.5S11.72 11 12.55 11s1.48-.67 1.48-1.5-.67-1.5-1.48-1.5m3.5-3h-11c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V6.5c0-1.1-.9-2-2-2zm0 16h-11v-12h11v12z" />
                </svg>
                iOS Apps
              </h4>
              <div className="app-links-grid">
                <a
                  href="https://apps.apple.com/us/app/ihariprabodham/id6749931306"
                  className="app-link"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="iHariPrabodham App"
                >
                  <img
                    src="/image/ihp.png"
                    alt="iHariPrabodham App"
                    style={{ width: 24, height: 24 }}
                  />
                </a>
                <a
                  href="https://apps.apple.com/in/app/hariprabodham/id6443796461"
                  className="app-link"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="HariPrabodham App"
                >
                  <img
                    src="/image/hp.png"
                    alt="HariPrabodham App"
                    style={{ width: 24, height: 24 }}
                  />
                </a>
                <a
                  href="https://apps.apple.com/in/app/paramrut/id6451111413"
                  className="app-link"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Paramrut App"
                >
                  <img
                    src="/image/paramrut.jpg"
                    alt="Paramrut App"
                    style={{ width: 24, height: 24 }}
                  />
                </a>
                <a
                  href="https://apps.apple.com/in/app/hari-kirtan/id1664675926"
                  className="app-link"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Hari Kirtan App"
                >
                  <img
                    src="/image/kirtan.png"
                    alt="Hari Kirtan App"
                    style={{ width: 24, height: 24 }}
                  />
                </a>
                <a
                  href="https://apps.apple.com/in/app/hariprabodham-vrund/id6474902923"
                  className="app-link"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Hariprabodham Vrund App"
                >
                  <img
                    src="/image/vrund.jpg"
                    alt="Hariprabodham Vrund App"
                    style={{ width: 24, height: 24 }}
                  />
                </a>
                <a
                  href="https://apps.apple.com/in/app/hariprabodham-smruti/id6770322140"
                  className="app-link"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Hariprabodham Smruti App"
                >
                  <img
                    src="/image/smruti.png"
                    alt="Hariprabodham Smruti App"
                    style={{ width: 24, height: 24 }}
                  />
                </a>

                <a
                  href="https://apps.apple.com/in/app/atmiya-calendar/id1643548754"
                  className="app-link"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Atmiya Calendar App"
                >
                  <img
                    src="/image/calendar.png"
                    alt="Atmiya Calendar App"
                    style={{ width: 24, height: 24 }}
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="footer-section our-community">
          <h3>Our Community</h3>
          <div className="community-links">
            <a
              href="https://www.youtube.com/@sharanagat936/"
              className="community-card"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="YouTube"
            >
              <span className="community-media-icon" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M22.54 6.42c-.26-1.17-1.04-2.09-2.12-2.35C18.88 3.5 12 3.5 12 3.5s-6.88 0-8.42.57c-1.08.26-1.86 1.18-2.12 2.35C.97 7.99.97 12 .97 12s0 4.01.37 5.58c.26 1.17 1.04 2.09 2.12 2.35 1.54.57 8.42.57 8.42.57s6.88 0 8.42-.57c1.08-.26 1.86-1.18 2.12-2.35.37-1.57.37-5.58.37-5.58s0-4.01-.37-5.58zM9.75 15.02v-6.04l5.38 3.02-5.38 3.02z" />
                </svg>
              </span>
              <span className="community-card-title">Hari na Das</span>
            </a>

            <a
              href="https://www.youtube.com/@HariPrabodhamMumbai/"
              className="community-card"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="YouTube"
            >
              <span className="community-media-icon" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M22.54 6.42c-.26-1.17-1.04-2.09-2.12-2.35C18.88 3.5 12 3.5 12 3.5s-6.88 0-8.42.57c-1.08.26-1.86 1.18-2.12 2.35C.97 7.99.97 12 .97 12s0 4.01.37 5.58c.26 1.17 1.04 2.09 2.12 2.35 1.54.57 8.42.57 8.42.57s6.88 0 8.42-.57c1.08-.26 1.86-1.18 2.12-2.35.37-1.57.37-5.58.37-5.58s0-4.01-.37-5.58zM9.75 15.02v-6.04l5.38 3.02-5.38 3.02z" />
                </svg>
              </span>
              <span className="community-card-title">Hariprabodham Mumbai</span>
            </a>

            <a
              href="https://www.youtube.com/@AksharYatra/"
              className="community-card"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="YouTube"
            >
              <span className="community-media-icon" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M22.54 6.42c-.26-1.17-1.04-2.09-2.12-2.35C18.88 3.5 12 3.5 12 3.5s-6.88 0-8.42.57c-1.08.26-1.86 1.18-2.12 2.35C.97 7.99.97 12 .97 12s0 4.01.37 5.58c.26 1.17 1.04 2.09 2.12 2.35 1.54.57 8.42.57 8.42.57s6.88 0 8.42-.57c1.08-.26 1.86-1.18 2.12-2.35.37-1.57.37-5.58.37-5.58s0-4.01-.37-5.58zM9.75 15.02v-6.04l5.38 3.02-5.38 3.02z" />
                </svg>
              </span>
              <span className="community-card-title">Hariprabodham Surat</span>
            </a>

            <a
              href="https://www.youtube.com/@BrahmVidya/"
              className="community-card"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="YouTube"
            >
              <span className="community-media-icon" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M22.54 6.42c-.26-1.17-1.04-2.09-2.12-2.35C18.88 3.5 12 3.5 12 3.5s-6.88 0-8.42.57c-1.08.26-1.86 1.18-2.12 2.35C.97 7.99.97 12 .97 12s0 4.01.37 5.58c.26 1.17 1.04 2.09 2.12 2.35 1.54.57 8.42.57 8.42.57s6.88 0 8.42-.57c1.08-.26 1.86-1.18 2.12-2.35.37-1.57.37-5.58.37-5.58s0-4.01-.37-5.58zM9.75 15.02v-6.04l5.38 3.02-5.38 3.02z" />
                </svg>
              </span>
              <span className="community-card-title">
                Hariprabodham Amadavad
              </span>
            </a>

            <a
              href="https://www.youtube.com/@hariprabodhamrajkot7429/"
              className="community-card"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="YouTube"
            >
              <span className="community-media-icon" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M22.54 6.42c-.26-1.17-1.04-2.09-2.12-2.35C18.88 3.5 12 3.5 12 3.5s-6.88 0-8.42.57c-1.08.26-1.86 1.18-2.12 2.35C.97 7.99.97 12 .97 12s0 4.01.37 5.58c.26 1.17 1.04 2.09 2.12 2.35 1.54.57 8.42.57 8.42.57s6.88 0 8.42-.57c1.08-.26 1.86-1.18 2.12-2.35.37-1.57.37-5.58.37-5.58s0-4.01-.37-5.58zM9.75 15.02v-6.04l5.38 3.02-5.38 3.02z" />
                </svg>
              </span>
              <span className="community-card-title">Hariprabodham Rajkot</span>
            </a>
          </div>
        </div>
        <div className="footer-section international-centers">
          <h3>International Centers</h3>
          <div className="centers-grid">
            {/* United States */}
            <div className="country-card">
              <a
                href="http://www.harisumiran.org"
                className="website-link"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="https://flagcdn.com/w40/us.png"
                  srcSet="https://flagcdn.com/w80/us.png 2x"
                  className="flag"
                  alt="United States"
                />
                <span>www.harisumiran.org</span>
              </a>
              <div className="social-icons1">
                <a
                  href="https://www.youtube.com/@harisumiran-nj"
                  className="social-icon1 youtube"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="YouTube"
                >
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
                  </svg>
                </a>
                <a
                  href="https://www.instagram.com/hariprabodham.us/"
                  className="social-icon1 instagram"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Instagram"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                  </svg>
                </a>
              </div>
            </div>

            {/* Canada */}
            <div className="country-card">
              <a
                href="http://www.ydscanada.org"
                className="website-link"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="https://flagcdn.com/w40/ca.png"
                  srcSet="https://flagcdn.com/w80/ca.png 2x"
                  className="flag"
                  alt="Canada"
                />
                <span>www.ydscanada.org</span>
              </a>
              <div className="social-icons1">
                <a
                  href="https://www.youtube.com/@ydscanada"
                  className="social-icon1 youtube"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="YouTube"
                >
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
                  </svg>
                </a>
                <a
                  href="https://www.instagram.com/ydscanada/"
                  className="social-icon1 instagram"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Instagram"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                  </svg>
                </a>
              </div>
            </div>

            {/* United Kingdom */}
            <div className="country-card">
              <a
                href="http://www.ydsuk.org"
                className="website-link"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="https://flagcdn.com/w40/gb.png"
                  srcSet="https://flagcdn.com/w80/gb.png 2x"
                  className="flag"
                  alt="United Kingdom"
                />
                <span>www.ydsuk.org</span>
              </a>
              <div className="social-icons1">
                <a
                  href="https://www.youtube.com/@Harisumiran369"
                  className="social-icon1 youtube"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="YouTube"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
                  </svg>
                </a>
                <a
                  href="https://www.instagram.com/suhradyouth/"
                  className="social-icon1 instagram"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Instagram"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                  </svg>
                </a>
              </div>
            </div>

            {/* Germany */}
            <div className="country-card">
              <a
                href="http://yds-germany.de"
                className="website-link"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="https://flagcdn.com/w40/de.png"
                  srcSet="https://flagcdn.com/w80/de.png 2x"
                  className="flag"
                  alt="Germany"
                />
                <span>www.yds-germany.de</span>
              </a>
              <div className="social-icons1">
                <a
                  href="https://www.youtube.com/@harisumiranDE"
                  className="social-icon1 youtube"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="YouTube"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
                  </svg>
                </a>
                <a
                  href="https://www.instagram.com/hariprabodhamgermany/"
                  className="social-icon1 instagram"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Instagram"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                  </svg>
                </a>
              </div>
            </div>

            {/* New Zealand */}
            <div className="country-card">
              <a
                href="https://hariprabodham.org.nz/"
                className="website-link"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="https://flagcdn.com/w40/nz.png"
                  srcSet="https://flagcdn.com/w80/nz.png 2x"
                  className="flag"
                  alt="New Zealand"
                />
                <span>www.hariprabodham.org.nz</span>
              </a>
              <div className="social-icons1">
                <a
                  href="https://www.youtube.com/@hariprabodhamnz"
                  className="social-icon1 youtube"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="YouTube"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
                  </svg>
                </a>
                <a
                  href="https://www.instagram.com/hariprabodhamnewzealand/"
                  className="social-icon1 instagram"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Instagram"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                  </svg>
                </a>
              </div>
            </div>

            {/* Australia */}
            <div className="country-card">
              <a
                href="https://hariprabodham.org.au/"
                className="website-link"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="https://flagcdn.com/w40/au.png"
                  srcSet="https://flagcdn.com/w80/au.png 2x"
                  className="flag"
                  alt="Australia"
                />
                <span>www.hariprabodham.org.au</span>
              </a>
              <div className="social-icons1">
                <a
                  href="https://www.youtube.com/@hariprabodhamaustralia"
                  className="social-icon1 youtube"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="YouTube"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
                  </svg>
                </a>
                <a
                  href="https://www.instagram.com/hariprabodham_australia/"
                  className="social-icon1 instagram"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Instagram"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ThemeSelector />
      <div className="footer-bottom">
        <p>&copy; 2025 iHariPrabodham.org, All rights reserved.</p>
        <p className="visitor-count">
          Visitors: <span id="visitorCount">{visitorCount}</span>
        </p>
      </div>
    </footer>
  );
}

export default Footer;
